/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextUrl = core.serialization.object({
    url: core.serialization.string(),
    label: core.serialization.string().optional(),
    replace: core.serialization.boolean().optional(),
});
